import { ImgHTMLAttributes, useState } from "react";
import fallbackImage from "../assets/img/fallback.png";

export const Image = ({
  src,
  alt,
  ...rest
}: ImgHTMLAttributes<HTMLImageElement>) => {
  const [imageSrc, setImageSrc] = useState(src || fallbackImage);

  return (
    <img
      src={imageSrc}
      alt={alt}
      onError={(e) => {
        setImageSrc(fallbackImage);
      }}
      {...rest}
    />
  );
};
